// src/components/Dashboard/ProfileViews.jsx
import React, { useEffect, useState } from "react";
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { format, parseISO, addDays } from "date-fns";

import api from "../../api/axios";

export default function ProfileViews() {
  const [data, setData] = useState({ chartData: [], topArticles: [], uniqueSeekers: 0, totalViews: 0 });
  const [range, setRange] = useState("7"); // '7' or '15'
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        const res = await api.get(`/analytics/dashboard?range=${range}`);
        setData(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, [range]);

  if (loading) return <div className="h-full flex items-center justify-center text-xs text-gray-400">Loading Stats...</div>;

  return (
    <div className="h-full flex flex-col">
      <div className="flex items-center justify-between mb-2">
        <div>
          <p className="text-2xl font-bold font-display">{data.totalViews}</p>
          <p className="text-xs text-gray-500">Total Visits</p>
        </div>

        <div className="bg-gray-100 p-1 rounded-lg flex text-xs">
          <button
            onClick={() => setRange("7")}
            className={`px-3 py-1 rounded transition-all ${range === "7" ? "bg-white shadow text-black font-medium" : "text-gray-500"}`}
          >
            7D
          </button>
          <button
            onClick={() => setRange("15")}
            className={`px-3 py-1 rounded transition-all ${range === "15" ? "bg-white shadow text-black font-medium" : "text-gray-500"}`}
          >
            15D
          </button>
        </div>
      </div>

      {/* Chart */}
      <div className="h-48 w-full -ml-4 mb-4">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data.chartData}>
            <defs>
              <linearGradient id="colorViews" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#6366f1" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#6366f1" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="colorPred" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#10b981" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#10b981" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f3f4f6" />
            <XAxis
              dataKey="date"
              tickFormatter={(str) => format(parseISO(str), "dd MMM")}
              tick={{ fontSize: 10, fill: "#9ca3af" }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis hide />
            <Tooltip
              contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' }}
              labelFormatter={(l) => format(parseISO(l), "MMM dd, yyyy")}
            />

            {/* Historical Data */}
            <Area
              type="monotone"
              dataKey={(d) => d.isPredicted ? null : d.views}
              stroke="#6366f1"
              strokeWidth={2}
              fillOpacity={1}
              fill="url(#colorViews)"
              name="Views"
            />

            {/* Predicted Data (Green) */}
            <Area
              type="monotone"
              dataKey={(d) => d.isPredicted ? d.views : null}
              stroke="#10b981"
              strokeWidth={2}
              strokeDasharray="5 5"
              fillOpacity={1}
              fill="url(#colorPred)"
              name="Projected"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>

      {/* Details Footer */}
      <div className="flex justify-between border-t pt-3 border-gray-100 mt-auto">
        <div>
          <p className="text-lg font-bold">{data.uniqueSeekers}</p>
          <p className="text-[10px] text-gray-500 uppercase tracking-wide">Unique Seekers</p>
        </div>


      </div>

    </div>
  );
}